export default {
  "Event template": "Modèle d’événement",
  "Choose an event template": "Choisir un modèle d’événement",
  "Prepare settings, draft emails and configuration checks for your event.": "Préparez les réglages, les emails en brouillon et les contrôles de votre événement.",
  "Start with a template. You can adjust your event configuration afterwards.": "Partez d’un modèle. Vous pourrez adapter la configuration de votre événement ensuite.",
  "Start without a template": "Commencer sans modèle",

  "QR code": "QR code",
  "Leads to the activity page on the event website.": "Renvoie vers la page de l’activité sur le site de l’événement.",
  "Invitation details": "Détail de l’invitation",
  "This member cannot sign in until they have chosen their password from the invitation email. Their permissions can be edited in the meantime.": "Ce membre ne peut pas se connecter tant qu’il n’a pas choisi son mot de passe depuis l’email d’invitation. Ses permissions restent modifiables entre-temps.",
  "Sending the invitation again issues a new link and invalidates the previous one.": "Renvoyer l’invitation génère un nouveau lien et invalide le précédent.",
  "Invited by": "Invité par",
  "Sent on": "Envoyée le",
  "Expires on": "Expire le",
  "Expired on": "Expirée le",
  "Only the email address is required. They will confirm their details and choose their own password from the invitation email.": "Seule l’adresse email est requise. La personne confirmera ses informations et choisira son mot de passe depuis l’email d’invitation.",
  "No user account found for this email. Invite this person to add them as a team member.": "Aucun compte ne correspond à cette adresse. Invitez cette personne pour l’ajouter à l’équipe.",
  "Invite this person": "Inviter cette personne",
  "Send the invitation": "Envoyer l’invitation",
  "Pending invitation": "Invitation en attente",
  "Invitation expired": "Invitation expirée",
  "Resend the invitation": "Renvoyer l’invitation",
  "The invitation has been sent again.": "L’invitation a été renvoyée.",
  "The invitation could not be sent again.": "L’invitation n’a pas pu être renvoyée.",
  "No event departs from your general preferences.": "Aucun événement ne s’écarte de vos préférences générales.",
  "Remove this exception": "Supprimer cette exception",
  "Set a preference for this event": "Définir un réglage pour cet événement",
  "Follow my general preference": "Suivre ma préférence générale",
  "Default": "Par défaut",
  "Notification preference saved": "Préférence de notification enregistrée",
  "Exceptions by event": "Exceptions par événement",
  "These events do not follow your general preferences. Removing an exception puts the event back in line with them.": "Ces événements ne suivent pas vos préférences générales. Supprimer une exception remet l’événement en accord avec elles.",
  "Unknown event": "Événement inconnu",
  "Receive": "Recevoir",
  "Do not receive": "Ne pas recevoir",
  "No barcode order": "Aucune commande de codes-barres",
  "barcodes_count": "1 code-barres | {count} codes-barres",
  "{count} barcodes assigned out of {requested} requested": "{count} codes-barres assignés sur {requested} demandés",
  "Barcodes": "Codes-barres",
  "real": "réels",
  "auto": "auto",
  "without": "sans",
  "No item in an event park": "Aucun article rattaché à un parc de l’event",
  "Customize": "Personnaliser",
  "Collapse": "Réduire",
  "Preset": "Préréglage",
  "Basic": "Essentiel",
  "Advanced": "Avancé",
  "Full": "Complet",
  "Choose columns to export": "Choisir les colonnes à exporter",
  "{count} columns selected": "{count} colonnes sélectionnées",
  "Loading...": "Chargement...",
  "An error occurred": "Une erreur est survenue",
  "Model Id": "ID du modèle",
  "Model reference": "Référence du modèle",
  "Model year": "Année du modèle",
  "Item Id": "ID de l’article",
  "Item barcode": "Code-barres de l’article",
  "Item size": "Taille de l’article",
  "Item color": "Couleur de l’article",
  "Item serial number": "Numéro de série de l’article",
  "Item reference": "Référence de l’article",
  "Nbr of tests": "Nombre de tests",
  "Current test event": "Événement du test en cours",
  "Current test start date": "Date de début du test en cours",
  "Current test end date": "Date de fin du test en cours",
  "Current tester name": "Nom du testeur actuel",
  "Current allotment start date": "Date de début de l’allotement en cours",
  "Current allotment end date": "Date de fin de l’allotement en cours",
  "Current allotment status": "Statut de l’allotement en cours",
  "Current allotment title": "Titre de l’allotement en cours",
  "Current allotment description": "Description de l’allotement en cours",
  "Add member": "Ajouter un membre",
  "Details": "Détails",
  "Add a member": "Ajouter un membre",
  "Create the user account": "Créer le compte utilisateur",
  "Color": "Couleur",
  "Color:": "Couleur :",
  "Generate password": "Générer un mot de passe",
  "Password must be 8 - 20 characters long.": "Le mot de passe doit comporter entre 8 et 20 caractères.",
  "Password": "Mot de passe",
  "Confirm Password": "Confirmer le mot de passe",
  "First name": "Prénom",
  "Last name": "Nom",
  "Company": "Société",
  "Language": "Langue",
  "Send information by email": "Envoyer les informations par e-mail",
  "No Barcode": "Aucun code-barres",
  "Change": "Modifier",
  "Duration:": "Durée :",
  "Duration": "Durée",
  "Custom duration": "Durée personnalisée",
  "equipment": "article",
  "Payment provider:": "Compte de paiement :",
  "registration": "participant",
  "Participant": "Participant",
  "No store selected": "Aucun magasin sélectionné",
  "No dates selected": "Aucune date sélectionnée",
  "No item selected": "Aucun article sélectionné",
  "No participant selected": "Aucun participant sélectionné",
  "Availability": "Disponibilités",
  "View availability": "Voir les disponibilités",
  "The period is chosen at the date step and cannot be changed here.": "La période se choisit à l’étape des dates et ne peut pas être modifiée ici.",
  "The dates changed since this item was picked. Check it is still available.": "Les dates ont changé depuis la sélection de ce matériel. Vérifiez qu’il est toujours disponible.",
  "Validate store": "Valider le magasin",
  "A confirmation code has just been sent to you by message": "Un code de confirmation vient de vous être envoyé par SMS",
  "Already have an account": "Vous avez déjà un compte",
  "Beyond this time, the reservation we retain will be available again for others": "Au-delà de ce délai, la réservation que nous conservons sera à nouveau disponible pour les autres",
  "Book now": "Réserver maintenant",
  "Booking": "Réservation",
  "Barcode": "Code-barres",
  "Barcode updated": "Code-barres mis à jour",
  "Brand": "Marque",
  "Serial number": "Numéro de série",
  "Serial number:": "Numéro de série :",
  "Parks": "Parcs",
  "Manage": "Gérer",
  "Model": "Modèle",
  "Models": "Modèles",
  "Model name": "Nom du modèle",
  "Item": "Article",
  "Items": "Articles",
  "Items list": "Liste des articles",
  "Detach": "Détacher",
  "Validated": "Validé",
  "Awaiting acceptance": "En attente d’acceptation",
  "Products": "Produits",
  "Parks linked": "Parcs liés",
  "No brands for this exhibitor yet.": "Aucune marque pour cet exposant pour l’instant.",
  "Catalog details will appear once the exhibitor accepts the invitation.": "Les détails du catalogue apparaîtront une fois que l’exposant aura accepté l’invitation.",
  "Items selected": "Aucun article sélectionné | 1 article sélectionné | {count} articles sélectionnés",
  "Item(s) selected": "Aucun article sélectionné | 1 article sélectionné | {count} articles sélectionnés",
  "Delete item(s)": "Supprimer l’article | Supprimer les articles",
  "Are you sure you want to delete the selected item(s)?": "Êtes-vous sûr de vouloir supprimer l’article sélectionné | Êtes-vous sûr de vouloir supprimer les articles sélectionnés ?",
  "Generate an automatic barcode": "Créer un code-barres automatique",
  "Automatic barcode": "Code-barres automatique",
  "Remove from other parks": "Retirer des autres parcs",
  "Archive model": "Archiver le modèle",
  "Are you sure you want to perform this bulk action on the selected models?": "Êtes-vous sûr de vouloir effectuer cette action groupée sur les modèles sélectionnés ?",
  "Confirm": "Confirmer",
  "Confirm my participation": "Confirmer ma participation",
  "Select the exhibitor you want to validate for this event": "Sélectionnez l’exposant que vous souhaitez valider pour cet événement",
  "Your participation to this event is not yet confirmed.": "Votre participation à cet événement n’est pas encore confirmée.",
  "Action required": "Action requise",
  "Delete associated items": "Supprimer les articles associés",
  "Booking information": "Informations de réservation",
  "View booking": "Voir la réservation",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "La réservation commence le premier jour à {startTime} et se termine le dernier jour à {endTime}",
  "Cancel booking": "Annuler la réservation",
  "An error occurred while processing your booking.": "Une erreur s’est produite lors du traitement de votre réservation.",
  "Choose your date": "Choisissez votre date",
  "Click to interact with the map": "Cliquer pour interagir avec la carte",
  "Confirm my phone number": "Confirmer mon numéro de téléphone",
  "Confirm my registration": "Valider mon inscription",
  "Confirm my registration and pay": "Valider mon inscription et payer",
  "Continue as guest": "Continuer en tant qu’invité",
  "Continue to registration": "Continuer vers l’inscription",
  "Create an account": "Créer un compte",
  "Dates": "Dates",
  "Dates:": "Dates :",
  "End Date of Reservation": "Date de fin de la réservation",
  "Enlarge map": "Agrandir la carte",
  "Enter your code here to confirm your registration": "Saisissez votre code ici pour confirmer votre inscription",
  "I accept the Terms and conditions of registration": "J’accepte les termes et conditions d’inscription",
  "Loading…": "Chargement…",
  "loading…": "chargement…",
  "Location": "Emplacement",
  "New location": "Nouvelle localisation",
  "Address": "Adresse",
  "Additional information": "Informations supplémentaires",
  "More information": "Plus d’informations",
  "No slots available": "Aucun créneau disponible",
  "Processing booking…": "Traitement de la réservation…",
  "Processing payment…": "Traitement du paiement…",
  "Product": "Produit",
  "Recording payment…": "Enregistrement du paiement…",
  "Reduce map": "Réduire la carte",
  "Remaining time": "Temps restant",
  "Required fields": "Champs obligatoires",
  "Reserving a product is mandatory for registration": "La réservation d’un produit est requise pour l’inscription",
  "Retrieving available slots": "Récupération des créneaux disponibles",
  "Saving registration…": "Enregistrement de l’inscription…",
  "Select size first": "Sélectionnez d’abord la taille",
  "Select stage first": "Sélectionnez d’abord la date",
  "Select your options and dates to book": "Sélectionnez vos options et dates pour réserver",
  "Size": "Taille",
  "Size:": "Taille :",
  "Slot": "Créneau",
  "Slot:": "Créneau :",
  "Date": "Date",
  "Date:": "Date :",
  "Stage": "Date",
  "Stage:": "Date :",
  "Store": "Magasin",
  "Calendar": "Calendrier",
  "Events": "Événements",
  "From: {date}": "Début : {date}",
  "To: {date}": "Fin : {date}",
  "Start at:": "Date de début :",
  "Start at": "Date de début",
  "End at:": "Date de fin :",
  "End at": "Date de fin",
  "Select booking dates": "Sélectionnez les dates de réservation",
  "numberOfDays": "0 jour | 1 jour | {d} jours",
  "at {date}": "le {date}",
  "Not Synchronized": "Non synchronisé",
  "Synchronizing…": "Synchronisation…",
  "Synchronization in progress…": "Synchronisation en cours…",
  "Synchronize now": "Synchroniser maintenant",
  "Synchronized": "Synchronisé",
  "Loading synchronization status…": "Chargement du statut de synchronisation…",
  "Waiting for server to complete synchronization…": "En attente que le serveur termine la synchronisation…",
  "View response details": "Voir les détails de la réponse",
  "No synchronization status available.": "Aucun statut de synchronisation disponible.",
  "Start Date of Reservation": "Date de début de la réservation",
  "View terms and conditions": "Voir les termes et conditions",
  "You do not want to create an account": "Vous ne souhaitez pas créer de compte",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "Le produit sélectionné a été mis de côté pour vous. Vous avez  {minutes} minutes pour compléter le processus en renseignant vos informations personnelles.",
  "Your reservation is in progress!": "Votre réservation est en cours !",
  "not available": "non disponible",
  "remaining place": "place restante|places restantes",
  "see availability": "voir la disponibilité",
  "Size available": "Taille disponible | Tailles disponibles",
  "park": "parc | parcs",
  "click to select": "cliquer pour sélectionner",
  "Parks configuration for {tour}": "Configuration des parcs pour {tour}",
  "The park for this event is defined by the organizer and applied automatically. There is no park to select, but you still need to add your items to the event park to make them available.": "Le parc pour cet événement est défini par l’organisateur et appliqué automatiquement. Il n’y a pas de parc à sélectionner, mais vous devez ajouter vos articles dans le parc événement pour les rendre disponibles. | Les parcs pour cet événement sont définis par l’organisateur et appliqués automatiquement. Il n’y a pas de parcs à sélectionner, mais vous devez ajouter vos articles dans les parcs événement pour les rendre disponibles.",
  "Event park": "Parc événement | Parcs événement",
  "Owned park": "Mon parc | Mes parcs",
  "Applied automatically": "Appliqué automatiquement",
  "Not available for this event": "Non disponible pour cet événement",
  "Event park automatically applied": "Parc événement appliqué automatiquement",
  "Model category": "Catégorie du modèle",
  "Product Name": "Nom du produit",
  "Year": "Année",
  "With item": "Avec article",
  "Stock": "Stock",
  "Tests": "Tests",
  "Reviews": "Avis",
  "Model Name": "Nom du modèle",
  "Models selected": "Aucun modèle sélectionné | 1 modèle sélectionné | {count} modèles sélectionnés",
  "items_count": "Aucun article | 1 article | {count} articles",
  "reviews_nbr": "aucun avis | 1 avis | {count} avis",
  "review": "avis | avis | avis",
  "tests_count": "aucun test | 1 test | {count} tests",
  "park_count": "aucun parc | 1 parc | {count} parcs",
  "Copy": "Copier",
  "Copied!": "Copié !",
  "Expiration": "Expiration",
  "Expiration date": "Date d’expiration",
  "References": "Références",
  "Condition": "État",
  "Bulk actions:": "Actions groupées :",
  "Check in": "Retour",
  "Checked out at": "Sorti le",
  "Checked in at": "Retourné le",
  "Undo check-in": "Annuler le retour",
  "Visibility": "Visibilité",
  "Set public": "Définir public",
  "Set private": "Définir privé",
  "Archive": "Archiver",
  "Restore": "Restaurer",
  "Archived": "Archivé",
  "Public": "Public",
  "Private": "Privé",
  "Please select a context to configure the parks availability": "Veuillez sélectionner un contexte pour configurer la disponibilité des parcs",
  "Selected parks will be available for the entire event": "Les parcs sélectionnés seront disponibles pour l’ensemble de l’événement",
  "Selected parks will be visible only on specific stage": "Les parcs sélectionnés seront visibles uniquement sur une date spécifique",
  "Selected parks will be visible only on specific store": "Les parcs sélectionnés seront visibles uniquement dans un magasin spécifique",
  "Select all": "Tout sélectionner",
  "Unselect all": "Tout désélectionner",
  "Save": "Enregistrer",
  "Save dates": "Enregistrer les dates",
  "Close": "Fermer",
  "Entire event": "Événement entier",
  "Specific stage": "Date spécifique",
  "Select a stage": "Sélectionner une date / étape",
  "Specific store": "Magasin spécifique",
  "Select a store": "Sélectionner un magasin",
  "Registration": "Participant",
  "Status": "Statut",
  "Active": "Actif",
  "Inactive": "Inactif",
  "No price": "Aucun prix",
  "Start date": "Date de début",
  "End date": "Date de fin",
  "Reset": "Réinitialiser",
  "Search": "Rechercher",
  "Today": "Aujourd’hui",
  "Tomorrow": "Demain",
  "After tomorrow": "Après-demain",
  "Next 7 Days": "7 prochains jours",
  "Monday": "Lundi",
  "Tuesday": "Mardi",
  "Wednesday": "Mercredi",
  "Thursday": "Jeudi",
  "Friday": "Vendredi",
  "Saturday": "Samedi",
  "Sunday": "Dimanche",
  "Opening Hours": "Horaires d’ouverture",
  "Booking Slot Times": "Créneaux de réservation",
  "Code": "Code",
  "Order": "Ordre",
  "Price": "Prix",
  "Sale period": "Période de mise en vente",
  "Select Activity Variant(s)": "Sélectionner la ou les variantes d’activité",
  "Variants list": "Liste des variantes",
  "Activities": "Activités",
  "Associated activity": "Activité associée",
  "variant": "pas de variante | 1 variante | {count} variantes",
  "Email Address": "Adresse e-mail",
  "Phone": "Téléphone",
  "Birthdate": "Date de naissance",
  "ProductTypes": "Types de produits",
  "Sizes": "Tailles",
  "Filter": "Filtrer",
  "Apply filters": "Appliquer les filtres",
  "Active filters": "Filtres actifs",
  "Search for a location": "Rechercher une adresse",
  "Current position": "Position actuelle",
  "This event is permanent": "Cet événement est permanent",
  "If not please specify the dates": "Si ce n’est pas le cas, veuillez spécifier les dates",
  "Timezone": "Fuseau horaire",
  "Select a date": "Sélectionner une date",
  "Free date": "Date libre",
  "Select an existing Registration": "Selectionner une inscription existante",
  "Confirm my booking": "Valider ma réservation",
  "Add a new Registration": "Ajouter une nouvelle inscription",
  "Registration deleted": "Inscription supprimée",
  "Create a deposit request": "Créer une demande de caution",
  "Payment of the Security Deposit": "Versement de la caution",
  "Welcome to the Security Deposit page! We invite you to provide a deposit to validate your registration. Rest assured, this is simply a bank authorization.": "Bienvenue sur la page de paiement de la caution ! Nous vous invitons à fournir une caution pour valider votre inscription. Soyez assuré, il s’agit simplement d’une autorisation bancaire.",
  "No amount will be debited from your account.": "Aucun montant ne sera débité de votre compte.",
  "This procedure allows us to verify that the funds are available.": "Cette procédure nous permet de vérifier que les fonds sont disponibles.",
  "At the end of the tests, the authorization will be automatically canceled, and the funds will be immediately available in your account again.": "À l’issue des tests, l’autorisation sera automatiquement annulée, et les fonds seront immédiatement à nouveau disponibles sur votre compte.",
  "Payment information": "Informations de paiement",
  "Confirm and authorize deposit": "Confirmer et autoriser la caution de {amount}",
  "Authorization Confirmation": "Confirmation de l’autorisation",
  "Your security deposit has been successfully authorized!": "Votre caution a été autorisée avec succès !",
  "Thank you for providing the necessary information. We have confirmed the authorization on your bank account.": "Merci d’avoir fourni les informations nécessaires. Nous avons confirmé l’autorisation de {amount} sur votre compte bancaire.",
  "Remember, no amount will be debited from your account at this stage.": "Rappelez-vous, aucun montant ne sera débité de votre compte.",
  "Processing deposit…": "Traitement de la caution…",
  "Saving deposit…": "Enregistrement de la caution…",
  "Deposit QR Code": "Code QR de la caution",
  "Add activity": "Ajouter une activité",
  "Payment method:": "Moyen de paiement :",
  "Add payment": "Ajouter un paiement",
  "Create Payment": "Créer un paiement",
  "Payment details": "Détails du paiement",
  "Amount": "Montant",
  "Reference (optional):": "Référence (facultatif) :",
  "Reference / SKU": "Référence / SKU",
  "Reference / SKU:": "Référence / SKU :",
  "Reference aliases": "Référence alternatives",
  "Add reference alias": "Ajouter une référence alternative",
  "Payment method": "Moyen de paiement",
  "Payments": "Paiements",
  "Created at:": "Créé le :",
  "Valid until:": "Valide jusqu’à :",
  "Save payment": "Enregistrer le paiement",
  "Refresh": "Actualiser",
  "Status:": "Statut :",
  "Amount:": "Montant :",
  "Due amount:": "Montant dû :",
  "Paid amount:": "Montant payé :",
  "Payment type:": "Type de paiement :",
  "Payment status:": "Statut du paiement :",
  "Payment mode:": "Mode de paiement :",
  "Payment reference:": "Référence de paiement :",
  "Creation date:": "Date de création :",
  "Update date:": "Date de mise à jour :",
  "Payment fee:": "Frais de paiement :",
  "Platform fee:": "Frais de plateforme :",
  "Net amount:": "Montant net :",
  "View on Stripe": "Voir sur Stripe",
  "Capturable amount:": "Montant disponible à capturer :",
  "Capture deposit": "Capturer la caution",
  "Amount to capture": "Montant à capturer",
  "Keep deposit": "Conserver la caution",
  "Confirm deposit capture": "Confirmer la capture de la caution",
  "Cancel deposit": "Annuler la caution",
  "Cancel payment": "Annuler le paiement",
  "Are you sure you want to cancel this deposit? This action cannot be undone.": "Êtes-vous sûr de vouloir annuler cette caution ? Cette action ne peut pas être annulée.",
  "Are you sure you want to cancel this payment? This action cannot be undone.": "Êtes-vous sûr de vouloir annuler ce paiement ? Cette action ne peut pas être annulée.",
  "Keep payment": "Conserver le paiement",
  "Confirm deposit cancellation": "Confirmer l’annulation de la caution",
  "Confirm payment cancellation": "Confirmer l’annulation du paiement",
  "Go to payment page": "Ouvrir la page de paiement",
  "Show QR Code": "Afficher le code QR",
  "Add filter": "Ajouter un filtre",
  "Results per page": "Résultats par page",
  "Results {start}-{end} of {total}": "Résultats {start}-{end} sur {total}",
  "Add": "Ajouter",
  "Card:": "Carte :",
  "Cancel": "Annuler",
  "Start test": "Démarrer le test",
  "Start a new test": "Démarrer un nouveau test",
  "Finish test": "Terminer le test",
  "Are you sure you want to finish the test?": "Êtes-vous sûr de vouloir terminer le test ?",
  "Created at": "Crée le",
  "Capture before": "Capture avant",
  "Paid at": "Payé le",
  "Due Amount": "Montant dû",
  "Paid Amount": "Montant payé",
  "Price:": "Prix :",
  "Select a tax rate": "Sélectionner un taux de taxe",
  "rate": "taux",
  "Tax rate": "Taux de taxe",
  "Current sale price": "Prix de vente actuel",
  "Original Price": "Prix d’origine",
  "If this price is set, it will appear as a “strikethrough price”. The “Current sale price” will always be applied in the cart.": "Si ce prix est défini, il apparaîtra comme un “prix barré”. Le “prix de vente actuel” sera toujours appliqué dans le panier.",
  "Tax inc.": "Taxe comprise",
  "Tax excl.": "Taxe exclue",
  "No result ?": "Aucun résultat ?",
  "Create new": "Créer un nouveau",
  "result": "Aucun résultat | 1 résultat | {count} résultats",
  "Export to Excel format": "Exporter au format Excel",
  "Target not set": "Cible non définie",
  "Define the recipient criteria here": "Définissez ici les critères des destinataires",
  "Add new group": "Ajouter un nouveau groupe",
  "Recipients": "Destinataires",
  "Conditions Group": "Groupe de conditions",
  "Contacts must match all of the following conditions": "Les contacts doivent correspondre à toutes les conditions suivantes",
  "Add new exhibitor": "Ajouter un nouvel exposant",
  "Associate an exhibitor to this tour": "Associer un exposant à cet événement",
  "Search for an exhibitor": "Rechercher un exposant",
  "Exhibitor or brand name": "Nom de l’exposant ou de la marque",
  "Finish the configuration": "Terminer la configuration",
  "Tested on {date}": "Testé le {date}",
  "Test no available": "Test non disponible",
  "You are not authorized to view this review": "Vous n’êtes pas autorisé à consulter cet avis",
  "Author:": "Auteur :",
  "Rating:": "Note :",
  "Publish on a third-party service": "Publier sur un service tiers",
  "Review": "Avis",
  "Publishing on a third-party service": "Publication sur un service tiers",
  "Select a service": "Sélectionner un service",
  "Select a service to publish the selected reviews.": "Sélectionnez un service pour publier les avis sélectionnés.",
  "Update status to “VALIDATED”": "Mettre à jour le statut en “VALIDÉ”",
  "{count} reviews selected": "Aucun avis sélectionné | 1 avis sélectionné | {count} avis sélectionnés",
  "Publish reviews": "Publier les avis",
  "new": "nouveau",
  "validated": "validé",
  "rejected": "rejeté",
  "Search Brand": "Rechercher une marque",
  "Star": "Étoile | Étoiles",
  "After:": "Après :",
  "Before:": "Avant :",
  "Export": "Exporter",
  "New draw": "Nouveau tirage",
  "park selected": "Aucun parc sélectionné | 1 parc sélectionné | {count} parcs sélectionnés",
  "In progress / Upcoming": "En cours / À venir",
  "Done / Archived": "Terminé / Archivé",
  "Contacts": "Contacts",
  "booking": "Réservation",
  "activity": "Activité",
  "payment": "Paiement",
  "Duplicate": "Dupliquer",
  "Manage variants": "Gérer les variantes",
  "Duplicate with variants": "Dupliquer avec les variantes",
  "A new activity will be created with the same settings as the original.": "Une nouvelle activité sera créée avec les mêmes paramètres que l’originale.",
  "If checked, all variants and their options will also be duplicated.": "Si coché, toutes les variantes et leurs options seront également dupliquées.",
  "Add new field": "Ajouter un nouveau champ",
  "Select fields to add": "Sélectionner les champs à ajouter",
  "Add field": "Ajouter le champ | Ajouter les champs",
  "Required for registration validation": "Requis pour la validation de l’inscription",
  "Remove": "Supprimer",
  "Display": "Afficher",
  "Display events": "Afficher les événements",
  "Hide": "Masquer",
  "Hide events": "Masquer les événements",
  "Required": "Requis",
  "Download": "Télécharger",
  "Sign here": "Signez ici",
  "Yes": "Oui",
  "No": "Non",
  "Select language": "Sélectionner la langue",
  "Translation filled in": "Traduction renseignée",
  "Translation missing": "Traduction manquante",
  "You must set up languages before setup custom fields": "Vous devez configurer les langues avant de paramétrer les champs personnalisés",
  "Choices not set": "Choix non définis",
  "{count} choice(s)": "{count} choix",
  "Search by reference, barcode or serial number": "Rechercher par référence, code-barres ou numéro de série",
  "Search by model name, barcode number, serial number, or reference": "Rechercher par nom du modèle, numéro de code-barres, numéro de série ou référence",
  "Search by name, email, company, phone number, or badge number": "Rechercher par nom, e-mail, société, numéro de téléphone ou numéro de badge",
  "Filter by": "Filtrer par",
  "product": "produit | produits",
  "status": "statut",
  "Test in progress?": "Test en cours ?",
  "Total:": "Total :",
  "Item deleted": "Article supprimé",
  "Validate Attendee": "Valider le participant",
  "Terms and Conditions": "Conditions Générales d’Utilisation",
  "Available Languages": "Langues disponibles",
  "Default language": "Langue par défaut",
  "The test started": "Le test a démarré",
  "Tester": "Testeur",
  "Edit": "Modifier",
  "Expected at": "Attendu à",
  "Expected return": "Retour attendu",
  "Comment": "Commentaire",
  "Add comment": "Ajouter un commentaire",
  "Activity": "Activité",
  "Search by order number, name, or email address": "Recherche par numéro de commande, nom ou adresse email",
  "Filters": "Filtres",
  "Option value": "Valeur d’option",
  "Created after": "Créé après",
  "Created before": "Créé avant",
  "Show deleted": "Afficher supprimé",
  "Add Review": "Ajouter un avis",
  "You are not allowed to read this review": "Vous n’êtes pas autorisé à lire cet avis",
  "(optional)": "(facultatif)",
  "Add expected return date": "Ajouter une date de retour attendue",
  "Set expected return date": "Définir la date de retour attendue",
  "Exponents": "Exposants",
  "Subscription": "Abonnement",
  "Terms of use": "Conditions d’utilisation",
  "Not accepted": "Non accepté",
  "Accepted": "Accepté",
  "Add Exponent": "Ajouter un exposant",
  "Select an exponent": "Sélectionner un exposant",
  "Select exponent to add": "Sélectionner un exposant à ajouter",
  "As guest": "En tant qu’invité",
  "Sender’s Name": "Nom de l’expéditeur",
  "Reply-To Email Address": "Adresse e-mail de réponse",
  "Email Options": "Options de l’e-mail",
  "Header Image": "Image d’en-tête",
  "Footer Image": "Image de pied de page",
  "Email Subject": "Objet de l’e-mail",
  "Email Message": "Message de l’e-mail",
  "From file:": "Du fichier :",
  "From date": "À partir du",
  "To date": "Jusqu’au",
  "To date: {date}": "Jusqu’au: {date}",
  "From date: {date}": "À partir du: {date}",
  "{fromDate} → {toDate}": "{fromDate} → {toDate}",
  "In progress": "En cours",
  "Late": "En retard",
  "Finished": "Terminé",
  "Message": "Message",
  "Select a message": "Sélectionner un message",
  "Send": "Envoyer",
  "New product test": "New product test",
  "Allotment": "Allotement",
  "Linked allotments modification": "Modification des allotements liés",
  "The “Apply to linked allotments” option is enabled by default; uncheck it if you do not wish to extend the modifications to the associated allotments.": "L’option “Appliquer aux allotements liés” est activée par défaut ; décochez-la si vous ne souhaitez pas étendre les modifications aux allotements associées.",
  "Allotment information": "Informations sur l’allotement",
  "Equipments": "Équipements",
  "Start": "Début",
  "End": "Fin",
  "Title": "Titre",
  "Allow booking during this period": "Autoriser la réservation pendant cette période",
  "Apply to linked allotments": "Appliquer aux allotements liés",
  "Allotments": "Allotements",
  "Delete allotments": "Supprimer les allotements",
  "Delete allotment": "Supprimer l’allotement",
  "Once you delete it, there is no going back. Please be certain.": "Une fois supprimé, il n’y a pas de retour en arrière. Veuillez en être certain.",
  "Delete all allotments": "Supprimer toutes les allotements",
  "Name (backoffice reference)": "Nom (référence backoffice)",
  "Delivery Channel": "Canal de diffusion",
  "Email": "E-mail",
  "SMS": "SMS",
  "Sending Method": "Méthode d’envoi",
  "Manual": "Manuel",
  "on demand": "à la demande",
  "Scheduled": "Planifié",
  "at a specific time": "à une heure spécifique",
  "Deferred send type": "Type d’envoi différé",
  "Sending date": "Date d’envoi",
  "Stop sending after": "Arrêter l’envoi après",
  "Automatic": "Automatique",
  "based on events": "basé sur des événements",
  "Trigger Event": "Événement déclencheur",
  "Time Offset from Trigger Event": "Décalage temporel par rapport à l’événement déclencheur",
  "Offset can be negative or positive, 0 means immediate": "Le décalage peut être négatif ou positif, 0 signifie immédiat",
  "Message template": "Modèle de message",
  "Select a template": "Sélectionner un modèle",
  "Maximum messages per recipient": "Nombre maximum de messages par destinataire",
  "Unlimited": "Illimité",
  "Leave empty for unlimited messages": "Laissez vide pour un nombre illimité de messages",
  "Country": "Pays",
  "Country and Time Zone": "Pays et fuseau horaire",
  "Event Dates": "Dates de l’événement",
  "Condition Group": "Groupe de conditions",
  "Conditions": "Conditions",
  "Behavior": "Comportement",
  "Add Condition": "Ajouter une condition",
  "Add Condition Group": "Ajouter un groupe de conditions",
  "Catalog": "Catalogue",
  "Organizations": "Organisations",
  "Admin": "Admin",
  "My account": "Mon compte",
  "Logout": "Déconnexion",
  "Give us your opinion": "Donnez-nous votre avis",
  "Thank you for your review!": "Merci pour votre avis !",
  "You can also review these products": "Vous pouvez également évaluer ces produits",
  "Undo": "Annuler",
  "Redo": "Rétablir",
  "Bold": "Gras",
  "Italic": "Italique",
  "Strikethrough": "Barré",
  "Paragraph": "Paragraphe",
  "Add a link": "Ajouter un lien",
  "Remove the link": "Supprimer le lien",
  "Add an image": "Ajouter une image",
  "Headings": "Titres",
  "Heading 2": "Titre 2",
  "Heading 3": "Titre 3",
  "Heading 4": "Titre 4",
  "Heading 5": "Titre 5",
  "Heading 6": "Titre 6",
  "Bullet list": "Liste à puces",
  "Numbered list": "Liste numérotée",
  "Clear formatting": "Effacer le formatage",
  "Source code": "Code source",
  "Create deposit": "Créer une caution",
  "Create Deposit for {name}": "Créer une caution pour {name}",
  "Access Type": "Type d’accès",
  "Permissions": "Autorisations",
  "Administrator": "Administrateur",
  "Remove member": "Supprimer le membre",
  "members": "membres",
  "admin": "admin",
  "user": "utilisateur",
  "Edit Order Item": "Modifier l’élément de commande",
  "Add Order Item": "Ajouter un élément de commande",
  "No registration selected": "Aucun participant sélectionné",
  "Quota:": "Quota :",
  "Used:": "Utilisé :",
  "Remaining:": "Restant :",
  "No limit": "Sans limite",
  "Add to order": "Ajouter à la commande",
  "number of participant": "1 participant | {nbr} participants",
  "You don’t have enough participants for this activity, you need to add:": "Vous n’avez pas assez de participants pour cette activité, vous devez ajouter :",
  "You have too many participants for this activity, you need to remove:": "Vous avez trop de participants pour cette activité, vous devez retirer :",
  "No variant selected": "No variant selected",
  "Scan QR Code": "Scanner le QR Code",
  "Select date": "Sélectionner une date",
  "Select a registration": "Sélectionner un participant",
  "Search by name, email, phone number or badge number": "Rechercher par nom, e-mail, numéro de téléphone ou numéro de badge",
  "Product test information": "Information sur le test",
  "Value": "Valeur",
  "Label": "Label",
  "Add Option": "Ajouter une option",
  "Options": "Options",
  "park(s)": "parc | parcs",
  "Search a location": "Rechercher un lieu",
  "If this price is set, it will appear as a ": "Si ce prix est défini, il apparaîtra comme un ",
  "Select All": "Tout sélectionner",
  "Unselect All": "Tout désélectionner",
  "Minutes": "Minutes",
  "Hours": "Heures",
  "Days": "Jours",
  "Select all items": "Sélectionner tous les éléments",
  "No slots configured for this stage.": "Aucun créneau configuré pour cette étape.",
  "Slot setting": "Paramètre de créneau",
  "slot information": "information de créneau",
  "Configuration conflict!": "Conflit de configuration !",
  "saving…": "enregistrement…",
  "delete": "supprimer",
  "Add new slot": "Ajouter un nouveau créneau",
  "Add signature": "Ajouter une signature",
  "Delete signature": "Supprimer la signature",
  "Signature": "Signature",
  "Apply": "Appliquer",
  "Update status to ": "Mettre à jour le statut vers ",
  "Add condition": "Ajouter une condition",
  "Configure {field}": "Configurer {field}",
  "Choose where this field is asked and how it is answered.": "Choisissez où ce champ est demandé et comment il est renseigné.",
  "Done": "Terminé",
  "Extra": "Extra",
  "Consent": "Consentement",
  "Validation": "Validation",
  "Registration custom fields": "Champs personnalisés d’inscription",
  "Auto-generated from the default locale translation": "Généré automatiquement à partir de la traduction de la langue par défaut",
  "Edit option": "Modifier l’option",
  "Confirm deletion": "Confirmer la suppression",
  "Are you sure you want to delete this option?": "Êtes-vous sûr de vouloir supprimer cette option ?",
  "Are you sure you want to delete this field?": "Êtes-vous sûr de vouloir supprimer ce champ ?",
  "This action cannot be undone.": "Cette action ne peut pas être annulée.",
  "You haven’t created custom fields yet": "Vous n’avez pas encore créé de champs personnalisés.",
  "Custom fields allow you to collect additional information during registration.": "Les champs personnalisés vous permettent de collecter des informations supplémentaires lors de l’inscription.",
  "Changes detected": "Modifications détectées",
  "To validate your modification, save the configuration at the bottom of the page": "Pour valider votre modification, enregistrez la configuration en bas de la page",
  "Reference": "Référence",
  "(internal)": "(interne)",
  "Field type": "Type de champ",
  "Only seen in the back office, to find the consent in the forms.": "Visible uniquement dans le back-office, pour retrouver le consentement dans les formulaires.",
  "Name": "Nom",
  "Field label": "Libellé du champ",
  "Option label": "Libellé de l’option",
  "(public)": "(public)",
  "Text": "Texte",
  "Add new option": "Ajouter une nouvelle option",
  "Field configuration": "Configuration du champ",
  "Select variant(s)": "Sélectionner la/les variante(s)",
  "Select Field": "Sélectionner un champ",
  "Select Operation": "Sélectionner une opération",
  "Select Value": "Sélectionner une valeur",
  "Select Rule Type": "Sélectionner un type de règle",
  "Select position": "Sélectionner une position",
  "Note:": "Note :",
  "Confirmation": "Confirmation",
  "Validate selection": "Valider la sélection",
  "Current price:": "Prix actuel :",
  "Activity price:": "Prix de l’activité :",
  "Edit activity": "Modifier l’activité",
  "Distance": "Distance",
  "no barcode": "aucun code-barres",
  "has comment": "a un commentaire",
  "Select item": "Sélectionner un article",
  "Select an item": "Sélectionner un article",
  "Create booking": "Créer une réservation",
  "Searching…": "Recherche en cours…",
  "Notify members": "Notifier les membres",
  "Show example": "Afficher l’exemple",
  "Dynamic content": "Contenu dynamique",
  "Dynamic content example": "Exemple de contenu dynamique",
  "Field": "Champ",
  "You haven’t created custom fields yet.": "Vous n’avez pas encore créé de champs personnalisés.",
  "Value example": "Exemple de valeur",
  "Sender": "Expéditeur",
  "Select your date": "Sélectionnez votre date",
  "The “Apply to linked allotments“ option is enabled by default; uncheck it if you do not wish to extend the modifications to the associated allotments.": "L’option “Appliquer aux allotements liés“ est activée par défaut ; décochez-la si vous ne souhaitez pas étendre les modifications aux allotements associés.",
  "Stripe dashboard:": "Tableau de bord Stripe :",
  "Search by payment reference or registration name": "Rechercher par référence de paiement ou nom d’inscription",
  "What’s new": "Nouveautés",
  "Notifications": "Notifications",
  "Processing…": "En cours de traitement…",
  "Process complete – The page will reload": "Traitement terminé - La page va se rafraichir",
  "Are you sure?": "Êtes-vous sûr ?",
  "This action cannot be undone. This will permanently remove this member’s access.": "Cette action ne peut pas être annulée. Cela supprimera définitivement l’accès de ce membre.",
  "Delete": "Supprimer",
  "Member successfully added": "Membre ajouté avec succès",
  "A new member has been added. Do you want to edit the permission for this member?": "Un nouveau membre a été ajouté. Souhaitez-vous modifier les permissions de ce membre ?",
  "Later": "Plus tard",
  "Edit permissions": "Modifier les permissions",
  "numberOfPermissions": "0 autorisation | 1 autorisation | {count} autorisations",
  "User": "Utilisateur",
  "Member": "Membre",
  "Entity": "Entité",
  "Action": "Action",
  "Actions": "Actions",
  "Edit member": "Édition du membre",
  "Team Members": "Membres de l’équipe",
  "Setup": "Paramètres",
  "Manage catalog": "Gérer le catalogue",
  "Manage items": "Gérer les articles",
  "Allows managing global settings for the exponent configuration.": "Permet de gérer les paramètres globaux de l’exposant.",
  "Allows creating and editing models and items linked to the exponent.": "Permet de créer et modifier les modèles et articles liés à l’exposant.",
  "Manage tours": "Gérer les tournées",
  "Manage exponents": "Gérer les exposants",
  "Stripe accounts": "Comptes Stripe",
  "Allows managing global settings for the organization.": "Permet de gérer les paramètres globaux de l’organisation.",
  "Allows managing all tours within the organization.": "Permet de gérer toutes les tournées de l’organisation.",
  "Allows managing all exponents under the organization.": "Permet de gérer tous les exposants de l’organisation.",
  "Allows connecting and managing the organization’s Stripe accounts.": "Permet de connecter et gérer les comptes Stripe de l’organisation.",
  "Edit park": "Modifier le parc",
  "Allows editing the park’s settings and details.": "Permet de modifier les paramètres et les informations du parc.",
  "Edit stage": "Modifier l’étape",
  "Manage registrations": "Gérer les inscriptions",
  "Create product tests": "Créer des tests produits",
  "Manage bookings": "Gérer les réservations",
  "Allows updating the stage settings and information.": "Permet de modifier les paramètres et les informations de l’étape.",
  "Allows managing registrations associated with the stage.": "Permet de gérer les inscriptions liées à l’étape.",
  "Allows recording product tests during the stage.": "Permet d’enregistrer des tests produits pendant l’étape.",
  "Allows managing participant bookings for the stage.": "Permet de gérer les réservations des participants à l’étape.",
  "Edit store": "Modifier le magasin",
  "Allows updating the store settings and information.": "Permet de modifier les paramètres et informations du magasin.",
  "Allows managing registrations associated with the store.": "Permet de gérer les inscriptions liées au magasin.",
  "Allows creating and recording product tests in the store.": "Permet de créer et d’enregistrer des tests produits dans le magasin.",
  "Allows managing participant bookings for the store.": "Permet de gérer les réservations des participants dans le magasin.",
  "Configure settings": "Configurer les paramètres",
  "View products": "Voir les produits",
  "Manage product tests": "Gérer les tests produits",
  "View reviews": "Voir les avis",
  "View statistics": "Voir les statistiques",
  "Create marketing messages": "Créer des messages marketing",
  "Send marketing messages": "Envoyer des messages marketing",
  "Media Library": "Bibliothèque de médias",
  "No media found.": "Aucun média trouvé.",
  "Uploading…": "Téléchargement en cours…",
  "{width} pixels width": "{width} pixels de largeur",
  "Drop files here or click to upload.": "Déposez des fichiers ici ou cliquez pour télécharger.",
  "Dynamic contents was successfully imported": "Le contenu dynamique a été importé avec succès",
  "Dynamic contents was successfully removed": "Le contenu dynamique a été supprimé avec succès",
  "Import": "Importer",
  "Delete the image": "Supprimer l’image",
  "View bookings": "Voir les réservations",
  "View orders": "Voir les commandes",
  "Update orders": "Modifier les commandes",
  "View payments": "Voir les paiements",
  "Update payments": "Modifier les paiements",
  "Allows configuring the general settings of the event.": "Permet de configurer les paramètres généraux de l’événement.",
  "Allows managing participant registrations for the event.": "Permet de gérer les inscriptions des participants à l’événement.",
  "Allows viewing products linked to the event.": "Permet de consulter les produits liés à l’événement.",
  "Allows managing product tests during the event.": "Permet de gérer les tests produits pendant l’événement.",
  "Allows viewing products reviews.": "Permet de consulter les avis sur les produits.",
  "Allows viewing event statistics.": "Permet de consulter les statistiques de l’événement.",
  "Allows creating marketing messages for the event.": "Permet de créer des messages marketing pour l’événement.",
  "Allows sending marketing messages to participants.": "Permet d’envoyer des messages marketing aux participants.",
  "Allows managing participant bookings for the event.": "Permet de gérer les réservations des participants à l’événement.",
  "Allows viewing bookings for the event in read-only.": "Permet de consulter les réservations de l’événement en lecture seule.",
  "Allows viewing orders related to the event.": "Permet de consulter les commandes liées à l’événement.",
  "Allows updating existing orders for the event.": "Permet de modifier les commandes existantes de l’événement.",
  "Allows viewing payment information for the event.": "Permet de consulter les informations de paiement de l’événement.",
  "Allows updating and managing event payments.": "Permet de modifier et gérer les paiements de l’événement.",
  "Add an item": "Ajouter un article",
  "Filter type": "Type de filtre",
  "Filter value": "Valeur du filtre",
  "Edit filter": "Modifier le filtre",
  "Remove filter": "Supprimer le filtre",
  "Filter by {type}": "Filtrer par {type}",
  "{firstLabel} and {count} more": "{firstLabel} et {count} de plus",
  "{labels} · {toggle}: {state}": "{labels} · {toggle} : {state}",
  "Remove all filters": "Supprimer tous les filtres",
  "Filter values": "Valeurs du filtre",
  "Test in progress": "Test en cours",
  "Park": "Parc",
  "User not found": "Utilisateur introuvable",
  "No user account found for this email. Please create one to add the user as a team member.": "Aucun compte utilisateur trouvé pour cette adresse e-mail. Veuillez en créer un pour ajouter l’utilisateur comme membre de l’équipe.",
  "Create a user account": "Créer un compte utilisateur",
  "Create user & add member": "Créer un utilisateur et l’ajouter comme membre",
  "No {modelName} found": "Aucun {modelName} trouvé",
  "No {modelName} found matching your search or filters.": "Aucun {modelName} trouvé correspondant à votre recherche ou vos filtres.",
  "Create new {modelName}": "Créer un nouveau {modelName}",
  "activities": "Aucune activité | 1 activité | {count} activités",
  "Set date": "Définir la date",
  "No comment": "Aucun commentaire",
  "Enter your comment here…": "Entrez votre commentaire ici…",
  "Overall Rating": "Note globale",
  "Review title": "Titre de l’avis",
  "Ready to buy it": "Prêt à l’acheter",
  "Not ready to buy it": "Pas prêt à l’acheter",
  "Recommend to friends": "Recommande à des amis",
  "Do not recommend to friends": "Ne recommande pas à des amis",
  "Author": "Auteur",
  "{count} review(s) queued for publication": "Aucun avis en cours de publication | 1 avis en cours de publication | {count} avis en cours de publication",
  "Summarize your impression on the product": "Résumez votre impression sur le produit",
  "Your detailed product review": "Votre avis détaillé sur le produit",
  "50 characters minimum": "50 caractères minimum",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "Quelles ont été vos impressions lors du test du produit ? Qu’avez-vous aimé ou moins aimé ? Dans quelles conditions avez-vous testé le produit ?",
  "50 characters (minimum)": "50 caractères (minimum)",
  "Comments": "Commentaires",
  "Comments on the reception, the organization, the advice on the product…": "Commentaires sur l’accueil, l’organisation, les conseils sur le produit…",
  "Would you recommend this product to a friend?": "Recommanderiez-vous ce produit à un ami ?",
  "Would you be ready to buy this product?": "Seriez-vous prêt à acheter ce produit ?",
  "First name or pseudo": "Prénom ou pseudo",
  "Your name / nickname is published with your review": "Votre nom / pseudo sera publié avec votre avis",
  "I have read and I accept the terms and conditions": "J’ai lu et j’accepte les conditions générales",
  "of publication of the reviews": "de publication des avis",
  "and": "et",
  "the privacy policy": "la politique de confidentialité",
  "Post Review": "Publier l’avis",
  "Very bad": "Très mauvais",
  "Bad": "Mauvais",
  "Average": "Moyen",
  "Good": "Bon",
  "Great!": "Super !",
  "Image caption": "Légende de l’image",
  "Loading product test…": "Chargement du test produit…",
  "Expected return date": "Date de retour attendue",
  "This will permanently delete this allotment and all linked allotments. This action cannot be undone.": "Cette action supprimera définitivement cet allotement et tous les allotements liés. Cette action ne peut pas être annulée.",
  "This will permanently delete this allotment. This action cannot be undone.": "Cette action supprimera définitivement cet allotement. Cette action ne peut pas être annulée.",
  "Message sent successfully.": "Message envoyé avec succès.",
  "Quota": "Quota",
  "Sales start at": "Début des ventes",
  "Sales end at": "Fin des ventes",
  "Variant Edit": "Édition de la variante",
  "Variant": "Variante",
  "Associated stages": "Étapes associées",
  "Associated stages/dates": "Étapes/dates associées",
  "optional": "facultatif",
  "Select one or more stages that participants will automatically be associated to when ordering this variant.": "Sélectionnez une ou plusieurs étapes auxquelles les participants seront automatiquement associés lors de la commande de cette variante.",
  "Type": "Type",
  "Create deposit batch": "Créer un lot de cautions",
  "All activities": "Toutes les activités",
  "Create": "Créer",
  "Started at": "Commencé le",
  "Completed at": "Terminé le",
  "Outcome state": "État final",
  "Performed by": "Réalisé par",
  "Create new record": "Créer une maintenance",
  "Edit maintenance record": "Modifier la maintenance",
  "Create maintenance record": "Créer une maintenance",
  "Select a type": "Sélectionner un type",
  "Subtype": "Sous-type",
  "Short description of the intervention": "Description courte de l’intervention",
  "Select a status": "Sélectionner un statut",
  "Item condition": "État de l’objet",
  "Select a condition": "Sélectionner un état",
  "Next check at": "Prochaine vérification le",
  "Time spent (minutes)": "Temps de travail (minutes)",
  "Duration in minutes": "Durée en minutes",
  "Cost": "Coût",
  "Currency": "Devise",
  "Select a currency": "Sélectionner une devise",
  "Notes": "Notes",
  "Additional details about the maintenance...": "Détails supplémentaires concernant la maintenance...",
  "Saving…": "Enregistrement…",
  "Update": "Mettre à jour",
  "An error occurred while saving the maintenance record": "Une erreur est survenue lors de l’enregistrement de la fiche",
  "Add maintenance record": "Ajouter une maintenance",
  "No maintenance records found": "Aucune maintenance trouvée",
  "View": "Voir",
  "Successfully subscribed to notifications": "Vous êtes maintenant abonné aux notifications",
  "Successfully unsubscribed from notifications": "Vous êtes maintenant désabonné des notifications",
  "Failed to update notification subscription": "Impossible de mettre à jour l’abonnement aux notifications",
  "What do you want to import ?": "Que voulez-vous importer ?",
  "Update only": "Mettre à jour uniquement",
  "If checked, only existing models/items will be updated, new ones will be ignored": "Si coché, seuls les modèles/articles existants seront mis à jour, les nouveaux seront ignorés",
  "How do you want to identify your models or items?": "Comment souhaitez-vous identifier vos modèles ou articles ?",
  "The Identifier determines how models or items are uniquely matched:": "L’identifiant détermine comment les modèles ou articles sont appariés de manière unique :",
  "Model Reference: ensures models are unique to a brand using their reference.": "Référence modèle : garantit que les modèle sont uniques pour une marque en utilisant leur référence.",
  "Model Name: checks uniqueness based on the model name.": "Nom du modèle : vérifie l’unicité en fonction du nom des modèles.",
  "QR Code: ensures each item is unique using its QR code.": "QR Code : garantit que chaque article est unique en utilisant son code.",
  "This setup helps the system efficiently update existing items or associate them with the correct model.": "Cette configuration aide le système à mettre à jour efficacement les articles existants ou les associer au bon modèle.",
  "Example: A model with the reference ‘ABC123’ and name ‘Ski Boots X’ can be matched using either Model Reference or Model Name, depending on your file structure.": "Exemple : un modèle avec la référence ‘ABC123’ et le nom ‘Chaussures de ski X’ peut être apparié en utilisant soit la référence modèle, soit le nom du modèle, en fonction de la structure de votre fichier.",
  "Duplicate Identifiers in your file will be ignored during import to prevent conflicts.": "Les identifiants dupliqués dans votre fichier seront ignorés lors de l’importation pour éviter les conflits.",
  "Make sure each item in your file has a unique Identifier to ensure accurate matching and updates.": "Assurez-vous que chaque élément de votre fichier possède un identifiant unique pour garantir des appariements et des mises à jour précis.",
  "Select the columns corresponding to the fields": "Sélectionnez les colonnes correspondant aux champs",
  "Match the fields with the columns of the file.": "Associez les champs aux colonnes du fichier.",
  "If a field is not matched, it will not be imported/updated.": "Si un champ n’est pas associé, il ne sera pas importé/mis à jour.",
  "Model information": "Informations sur le modèle",
  "Item information": "Informations sur l’article",
  "Auto Generated Barcode": "Code-barres généré automatiquement",
  "If no column is selected for Barcode / QR Code, barcodes will be autogenerated for each item.": "Si aucune colonne n’est sélectionnée pour le code-barres / QR code, des codes-barres seront générés automatiquement pour chaque item.",
  "Add items to park": "Ajouter des articles au parc",
  "Add items to {target}": "Ajouter des articles au/à l’{target}",
  "Add to inventory": "Ajouter à l’inventaire",
  "Add to park": "Ajouter au parc",
  "inventory": "inventaire",
  "Important:": "Important :",
  "Save all quotas": "Enregistrer tous les quotas",
  "Total quota": "Quota total",
  "Assign to another model": "Assigner à un autre modèle",
  "Associated tests will be moved.": "Les tests associés seront déplacés.",
  "Linked reviews and ratings will also be transferred.": "Les avis et évaluations liés seront également transférés.",
  "Select a model": "Sélectionner un modèle",
  "History": "Historique",
  "Delete this item": "Supprimer cet article",
  "Delete this model": "Supprimer ce modèle",
  "Delete this question": "Supprimer cette question",
  "Delete this brand": "Supprimer cette marque",
  "Delete this exponent": "Supprimer cet exposant",
  "Delete this template": "Supprimer ce modèle d’avis",
  "Delete this park": "Supprimer ce parc",
  "Delete this metafield": "Supprimer ce champ méta",
  "Delete this registration": "Supprimer cette inscription",
  "Delete this registration (GDPR request)": "Supprimer cette inscription (demande RGPD)",
  "Delete this review": "Supprimer cet avis",
  "Delete this activity": "Supprimer cette activité",
  "Delete this option": "Supprimer cette option",
  "Delete this value": "Supprimer cette valeur",
  "Delete this promotion": "Supprimer cette promotion",
  "Delete this registration form": "Supprimer ce formulaire d’inscription",
  "Delete this stage": "Supprimer cette étape",
  "Delete this stand layout": "Supprimer ce plan de village",
  "Delete this tax rate": "Supprimer ce taux de taxe",
  "Delete this third party service": "Supprimer ce service tiers",
  "{historyType} for {userLink}": "{historyType} pour {userLink}",
  "Product test": "Test produit",
  "Ongoing": "En cours",
  "Upcoming": "À venir",
  "Ended": "Terminé",
  "Description": "Description",
  "Stages": "Étapes",
  "Tags": "Tags",
  "Tests count": "Nombre de tests",
  "Previous": "Précédent",
  "Next": "Suivant",
  "Booking dates": "Dates de réservation",
  "Unsupported filter type: {type}": "Type de filtre non pris en charge : {type}",
  "Product Test": "Test Produit",
  "Associated members to notify": "Membres associés à notifier",
  "Resend invitation": "Renvoyer l’invitation",
  "Send invitation": "Envoyer l’invitation",
  "Item status": "Statut de l’article",
  "Item health state": "État de santé de l’article",
  "number of SMS": "{length} caractères · {encoding} · {segments} SMS",
  "You must accept the terms of use to continue.": "Vous devez accepter les conditions d’utilisation pour continuer.",
  "Published on {date}": "Publié le {date}",
  "I accept the terms of use": "J’accepte les conditions d’utilisation",
  "Saving...": "Enregistrement...",
  "Install": "Installer",
  "Change URL": "Changer l’URL",
  "Change the event URL": "Changer l’URL de l’événement",
  "New URL": "Nouvelle URL",
  "Update slug": "Mettre à jour le slug",
  "Add parameter": "Ajouter un paramètre",
  "Order Details": "Détails de la commande",
  "Quantity": "Quantité",
  "Order Barcode Labels": "Commander des étiquettes codes-barres",
  "Company Name": "Nom de l’entreprise",
  "Recipient Name": "Nom du destinataire",
  "Search Address": "Rechercher une adresse",
  "Full Address": "Adresse complète",
  "Will be rounded up to": "Arrondi à",
  "barcodes": "codes-barres",
  "Delivery Address": "Adresse de livraison",
  "Barcode orders": "Commandes de codes-barres",
  "Exponent": "Exposant",
  "Step 1 — Configure filters": "Étape 1 — Configurer les filtres",
  "Refine the data range to include in your export.": "Affinez la plage de données à inclure dans votre export.",
  "Step 2 — Download the export": "Étape 2 — Télécharger l’export",
  "You will receive an email when the file is ready.": "Vous recevrez un e-mail lorsque le fichier sera prêt.",
  "Error": "Erreur",
  "Stop editing": "Arrêter la modification",
  "Edit barcodes": "Modifier les codes-barres",
  "Select": "Sélectionner",
  "No user account found for this email.": "Aucun compte utilisateur trouvé pour cet e-mail.",
  "Order on behalf of": "Commander au nom de",
  "Search by name or email...": "Rechercher par nom ou e-mail...",
  "Leave empty to create the order for yourself.": "Laissez vide pour créer la commande pour vous-même.",
  "Delete this payment provider": "Supprimer ce fournisseur de paiement",
  "Delete this inventory": "Supprimer cet inventaire",
  "Delete this variant": "Supprimer cette variante",
  "Type {text} to confirm": "Saisissez {text} pour confirmer",
  "Close inventory": "Clôturer l’inventaire",
  "Are you sure you want to close this inventory? This action cannot be undone.": "Êtes-vous sûr de vouloir clôturer cet inventaire ? Cette action est irréversible.",
  "Are you sure you want to archive this inventory?": "Êtes-vous sûr de vouloir archiver cet inventaire ?",
  "Delete all barcodes": "Supprimer tous les codes-barres",
  "Delete all barcodes of the registrations to reuse them on another event.": "Supprimer tous les codes-barres des inscriptions pour les réutiliser sur un autre événement.",
  "This action cannot be undone. All barcodes of the participants will be deleted.": "Cette action est irréversible. Tous les codes-barres des participants seront supprimés.",
  "Restore product": "Restaurer le produit",
  "Restored products can be used again": "Les produits restaurés peuvent être réutilisés",
  "Restore this product": "Restaurer ce produit",
  "Delete all permissions": "Supprimer toutes les permissions",
  "This permanently erases the registrant's personal data to satisfy a GDPR request. This action is irreversible.": "Cela efface définitivement les données personnelles de l’inscrit pour répondre à une demande RGPD. Cette action est irréversible.",
  "Delete all proof of identities": "Supprimer toutes les pièces d’identité",
  "Permanently delete every proof of identity file for the concerned registrations.": "Supprime définitivement chaque fichier de pièce d’identité des inscriptions concernées.",
  "This permanently deletes all proof of identity files. This action is immediate and cannot be undone.": "Cette action supprime définitivement toutes les pièces d’identité. Elle est immédiate et irréversible.",
  "Delete proof of identities": "Supprimer les pièces d’identité",
  "Delete all avatars": "Supprimer tous les avatars",
  "Permanently delete the avatar of the concerned registrations.": "Supprime définitivement l’avatar des inscriptions concernées.",
  "This permanently deletes all registration avatars. This action is immediate and cannot be undone.": "Cette action supprime définitivement tous les avatars des inscriptions. Elle est immédiate et irréversible.",
  "Delete avatars": "Supprimer les avatars",
  "Anonymize all registrations": "Anonymiser toutes les inscriptions",
  "Permanently replace personal data on the concerned registrations. Records are kept but anonymized.": "Remplace définitivement les données personnelles des inscriptions concernées. Les enregistrements sont conservés mais anonymisés.",
  "This permanently anonymizes all registrations (personal data is replaced). This action is immediate and cannot be undone.": "Cette action anonymise définitivement toutes les inscriptions (les données personnelles sont remplacées). Elle est immédiate et irréversible.",
  "Anonymize registrations": "Anonymiser les inscriptions",
  "Anonymize": "Anonymiser",
  "This field requires {field}": "Ce champ nécessite {field}",
  "{field} must also be displayed in: {contexts}": "{field} doit aussi être affiché dans : {contexts}",
  "Apply a rule to this field": "Appliquer une règle à ce champ",
  "Add a field that can drive a rule to the form first": "Ajoutez d’abord au formulaire un champ pouvant déclencher une règle",
  "only when all of:": "seulement si tout ceci est vrai :",
  "Add a condition": "Ajouter une condition",
  "Remove this condition": "Supprimer cette condition",
  "Effect": "Effet",
  "Age in years": "Âge en années",
  "Where this field appears": "Où ce champ apparaît",
  "Hidden": "Masqué",
  "Optional": "Facultatif",
  "Required to validate": "Obligatoire pour valider",
  "Required for a registration to be validated": "Obligatoire pour qu’une inscription soit validée",
  "Conditional": "Conditionnel",
  "Reorder": "Réordonner",
  "Online form": "Formulaire en ligne",
  "Mobile app": "Application mobile",
  "Export the orders": "Exporter les commandes",
  "Export the order items": "Exporter les lignes de commande",
  "The export could not be started.": "L’export n’a pas pu être lancé.",
  "Order number": "Numéro de commande",
  "Customer name": "Nom du client",
  "No customer": "Aucun client",
  "Deleted": "Supprimée",
  "Total Amount:": "Montant total :",
  "Participants": "Participants",
  "+ {count} more": "+ {count} de plus",
  "Order #": "Commande",
  "IP address": "Adresse IP",
  "Device": "Appareil",
  "Session": "Session",
  "Suspicious": "Suspecte",
  "Deleted user": "Utilisateur supprimé",
  "Successful": "Réussie",
  "Failed": "Échouée",
  "Unknown": "Inconnu",
  "Signed out at {time}": "Déconnexion à {time}",
  "Search by user or IP address": "Rechercher par utilisateur ou adresse IP",
  "Stock location": "Emplacement de stock",
  "Batch": "Lot",
  "Select a batch": "Sélectionner un lot",
  "{count} available": "{count} disponibles",
  "No available barcodes in this location": "Aucun code-barres disponible dans cet emplacement",
  "Header name": "Nom de l’en-tête",
  "Header value": "Valeur de l’en-tête",
  "Unchanged": "Inchangée",
  "Add a header": "Ajouter un en-tête",
  "This site is protected by reCAPTCHA.": "Ce site est protégé par reCAPTCHA.",
  "Google Privacy Policy": "Règles de confidentialité de Google",
  "Google Terms of Service": "Conditions d’utilisation de Google",
  "Decrease": "Baisse",
  "No change": "Stable",
  "Increase": "Hausse",
  "Others": "Autres",
  "No longer present:": "Absents désormais :",
  "was {share}": "{share} auparavant",
  "This figure could not be loaded.": "Ce chiffre n’a pas pu être chargé.",
  "Retry": "Réessayer",
  "No data for these filters.": "Aucune donnée pour ces filtres.",
  "Event": "Événement",
  "Registrations": "Participants",
  "A consent freely given cannot be required: the participant must be able to refuse it and still register.": "Un consentement libre ne peut pas être obligatoire : le participant doit pouvoir le refuser et s’inscrire quand même.",
  "For example:": "Par exemple :",
  "Channels": "Canaux",
  "Without a text of your own, the consent links to the public list of the exhibitors of the event:": "Sans texte de votre part, le consentement renvoie à la liste publique des exposants de l’événement :",
  "Without a text of your own, the consent links to the public list of the exhibitors of each event.": "Sans texte de votre part, le consentement renvoie à la liste publique des exposants de chaque événement.",
  "Each channel ticked gets its own box under the text. To word a text per channel, create one consent per channel.": "Chaque canal coché a sa propre case sous le texte. Pour rédiger un texte par canal, créez un consentement par canal.",
  "Full text (optional)": "Texte complet (facultatif)",
  "Written here": "Rédigé ici",
  "Link to an external page": "Lien vers une page externe",
  "Participants open this page from the form. Its content is yours to keep: the proof of consent records the link, not what the page says. Publish a new version when the page changes.": "Les participants ouvrent cette page depuis le formulaire. Son contenu reste sous votre responsabilité : la preuve du consentement enregistre le lien, pas ce que dit la page. Publiez une nouvelle version quand la page change.",
  "Word the consent in the languages of your participants. A language left empty is not offered.": "Rédigez le consentement dans les langues de vos participants. Une langue laissée vide n’est pas proposée.",
  "Label next to the box": "Libellé à côté de la case",
  "Participants have been shown this consent: its type, validation mode and channels no longer change. Create another consent to ask something else.": "Ce consentement a déjà été montré aux participants : son type, son mode de validation et ses canaux ne changent plus. Créez un autre consentement pour demander autre chose.",
  "Required to register": "Obligatoire pour s’inscrire",
  "Texts shown to participants": "Textes montrés aux participants",
  "Use the example": "Utiliser l’exemple",
  "Some languages already have a label. Should the example replace them?": "Certaines langues ont déjà un libellé. L’exemple doit-il les remplacer ?",
  "Fill the empty languages only": "Compléter les langues vides uniquement",
  "Replace every language": "Remplacer toutes les langues",
  "Validation mode": "Mode de validation",
  "What the consent stands for": "Ce que représente le consentement",
  "Read the full text": "Lire le texte complet",
  "Model custom field": "Champ personnalisé du modèle",
  "Item custom field": "Champ personnalisé de l’article",
  "What you are importing": "Ce que vous importez",
  "How existing models or items are identified": "Comment reconnaître les modèles ou articles existants",
  "A column for {field}": "Une colonne pour {field}",
  "Park for the new items": "Parc des nouveaux articles",
  "Upload": "Téléversement",
  "Match columns": "Correspondance des colonnes",
  "{count} rows": "{count} lignes",
  "{count} columns": "{count} colonnes",
  "{count} empty rows at the end of the file will be ignored.": "{count} lignes vides en fin de fichier seront ignorées.",
  "Replace file": "Remplacer le fichier",
  "What are you importing?": "Qu’importez-vous ?",
  "Content of the file": "Contenu du fichier",
  "Recognize existing models or items by": "Reconnaître les modèles ou articles existants par",
  "Choose what you are importing first.": "Choisissez d’abord ce que vous importez.",
  "Rows sharing the same identifier are ignored, so make sure each one is unique in your file.": "Les lignes qui partagent le même identifiant sont ignorées : assurez-vous que chacun est unique dans votre fichier.",
  "Match your columns": "Faites correspondre vos colonnes",
  "Pick the field each column of your file goes into. Columns left empty are not imported.": "Choisissez le champ dans lequel va chaque colonne de votre fichier. Les colonnes laissées vides ne sont pas importées.",
  "{count} of {total} columns imported": "{count} colonnes importées sur {total}",
  "Pre-filled with the settings of your last import": "Pré-rempli avec les réglages de votre dernier import",
  "{count} columns matched from their name, check them before importing": "{count} colonnes associées d’après leur nom, vérifiez-les avant d’importer",
  "Choose what you are importing to see the fields your columns can go into.": "Choisissez ce que vous importez pour voir les champs dans lesquels vos colonnes peuvent aller.",
  "Column in your file": "Colonne de votre fichier",
  "Imports as": "Importée comme",
  "Empty in the first row": "Vide sur la première ligne",
  "Don’t import": "Ne pas importer",
  "Also import into another field": "Importer aussi dans un autre champ",
  "Identifier": "Identifiant",
  "Matched from the column name": "Associée d’après le nom de la colonne",
  "Suggested": "Suggérée",
  "Matched": "Associée",
  "Not imported": "Non importée",
  "Applied to every row": "Appliqué à toutes les lignes",
  "These values do not come from your file.": "Ces valeurs ne viennent pas de votre fichier.",
  "Before importing": "Avant d’importer",
  "No column for Barcode / QR Code: a barcode will be generated for each new item.": "Aucune colonne pour le code-barres / QR code : un code-barres sera généré pour chaque nouvel article.",
  "Import {count} rows": "Importer {count} lignes",
  "Complete the steps above to start the import.": "Complétez les étapes ci-dessus pour lancer l’import.",
  "Already imported from {column}": "Déjà importé depuis {column}",
  "Withdraw": "Retirer",
  "Withdraw this consent": "Retirer ce consentement",
  "Record it only at the participant’s request. The participant will have to grant it again themselves to give it back.": "Ne l’enregistrez qu’à la demande du participant. Pour le redonner, il devra l’accorder lui-même à nouveau.",
  "Workflow": "Workflow",
  "No workflow": "Aucun workflow",
  "Workflows": "Workflows",
  "Outside workflows": "Hors workflow",
  "Automatic, no workflow": "Automatiques sans workflow",
  "Create a workflow": "Créer un workflow",
  "Edit the workflow": "Modifier le workflow",
  "Delete the workflow": "Supprimer le workflow",
  "Its messages stay, outside any workflow. Nothing changes in what they send.": "Ses messages restent, hors workflow. Rien ne change dans ce qu’ils envoient.",
  "No message in this workflow yet": "Aucun message dans ce workflow pour l’instant",
  "Pick the automatic messages of this use case, or create one and choose this workflow in its properties.": "Choisissez les messages automatiques de ce cas d’usage, ou créez-en un et choisissez ce workflow dans ses propriétés.",
  "Pick messages": "Choisir des messages",
  "None": "Aucun",
  "{n} message | {n} messages": "{n} message | {n} messages",
  "Every participant": "Tous les participants",
  "or": "ou",
  "Sent": "Envoyés",
  "Sending": "Envoi",
  "A workflow gathers the automatic messages of a use case, such as the life of a booking. The messages keep their own trigger, targeting and sending.": "Un workflow regroupe les messages automatiques d’un cas d’usage, comme la vie d’une réservation. Les messages gardent leur déclencheur, leur ciblage et leur envoi.",
  "Booking management": "Gestion réservation",
  "Automatic messages": "Messages automatiques",
  "The event has no automatic message yet. Create one and choose this workflow in its properties.": "L’événement n’a pas encore de message automatique. Créez-en un et choisissez ce workflow dans ses propriétés.",
  "In {name}": "Dans {name}",
  "A message belongs to one workflow at most: picking one from another workflow moves it here.": "Un message appartient à un seul workflow : en choisir un d’un autre workflow le déplace ici.",
  "The workflow could not be saved. Try again.": "Le workflow n’a pas pu être enregistré. Réessayez.",
  "Create the workflow": "Créer le workflow",
  "Start from": "Partir de",
  "From a template": "Partir d’un modèle",
  "Draft messages to adjust": "Messages en brouillon à ajuster",
  "Blank": "Personnalisé",
  "Pick existing messages": "Choisir des messages existants",
  "Template": "Modèle",
  "Its messages are created as drafts, for you to write and turn on.": "Ses messages sont créés en brouillon, à rédiger puis activer.",
  "Install the workflow": "Installer le workflow",
  "Add a trigger": "Ajouter un déclencheur",
  "Add a branch": "Ajouter une branche",
  "Create a message": "Créer un message",
  "{n} draft | {n} drafts": "{n} brouillon | {n} brouillons",
  "Trigger": "Déclencheur",
  "Until": "Jusqu’au",
  "Dynamic contents": "Contenus dynamiques",
  "Updated": "Modifié le",
  "Processing": "En cours de traitement",
  "View report": "Voir le rapport",
  "Delete the message": "Supprimer le message",
  "{name} will no longer be sent.": "{name} ne sera plus envoyé.",
  "Scheduled messages": "Messages programmés",
  "Manual messages": "Messages manuels",
  "AI usage": "Usage de l’IA",
  "Agent": "Agent",
  "Charged to": "Imputé à",
  "Input tokens": "Tokens en entrée",
  "Output tokens": "Tokens en sortie",
  "Cached input tokens": "Tokens en cache",
  "Reasoning tokens": "Tokens de raisonnement",
  "Calls": "Appels",
  "Steps": "Étapes",
  "Search by event, exhibitor, model or invocation": "Rechercher par événement, exposant, modèle ou appel",
  "Step {step}": "Étape {step}",
  "{count} cached": "{count} en cache",
  "{count} reasoning": "{count} de raisonnement",
  "Copy from {language}": "Copier depuis {language}",
  "Copy from another language": "Copier depuis une autre langue",
  "Copy from": "Copier depuis",
  "Nothing written in {language} yet": "Rien n’est encore rédigé en {language}",
  "Empty": "Vide",
  "Replace the text in {language}?": "Remplacer le texte en {language} ?",
  "What is written in {language} is replaced by the text in {source}. Nothing is saved until you save the form.": "Ce qui est rédigé en {language} est remplacé par le texte en {source}. Rien n’est enregistré tant que vous n’enregistrez pas le formulaire.",
  "Replace": "Remplacer",
  "Read the full text": "Lire le texte complet",
};
